<template>
	<div class="user">
		<div class="user__icon">
			<icon
			 name="user"
			 size="20px"
			/>
		</div>
		<div class="user__info">
			<div class="user__name">{{ username }}</div>
			<div
			 class="user__logout"
			 @click="logout()"
			>{{resource('logout')}}</div>
		</div>
	</div>
</template>
<style lang="scss">
.user {
	padding: $container $content;
	display: flex;
	&__icon {
		width: 35px;
		height: 35px;
		background: $user;
		color: #fff;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: $component;
	}
	&__name {
		font-weight: bold;
	}
	&__logout {
		color: $text;
		align-self: center;
		text-decoration: underline;
	}
}
</style>
<script>
import { applicationUserManager } from '../applicationUserManager'
export default {
	name: 'User',
	data() {
		return {
			user: {},
			res: {
				nl: {
					logout: 'Uitloggen'
				},
				fr: {
					logout: 'Logout'
				}
			}
		}
	},
	computed: {
		username() {
			if(this.$store.getters.user.profile){
				return this.$store.getters.user.profile.name
			}else{
				return '-'
			}
		}
	},
	methods: {
		resource(item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		async logout() {
			await applicationUserManager.logout()
		}
	}
}
</script>
